/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../common/graphql/generated/types';

export type OrganizationMemberInvitationContextMenu_OrganizationMemberInvitationFragment = { id: any };

export const OrganizationMemberInvitationContextMenu_OrganizationMemberInvitationFragmentDoc = `
    fragment OrganizationMemberInvitationContextMenu_OrganizationMemberInvitation on OrganizationMemberInvitations {
  id
}
    `;